module.exports = __webpack_public_path__ + "static/media/auction-contract-t1.c8a012c3.nom";